import DOMPurify from 'dompurify';
import { ChatbotChoice } from './chatbot_choice';
import { ChatbotDescription } from './chatbot_description';
export class ChatbotSection {
    constructor(data) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "choiceIconUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isEnd", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "descriptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "choices", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.choiceIconUrl = data.choiceIconUrl;
        this.title = data.title;
        this.isEnd = data.isEnd;
        this.descriptions = data.descriptions.map((v) => new ChatbotDescription(v));
        this.choices = data.choices.map((v) => new ChatbotChoice(v));
    }
}
export class ChatbotContent {
    constructor(config, sectionID, descriptionID, isAnswer, choiceIconUrl, isUnsubscribeButton, text, imageUrl, imageLinkUrl, nextSectionID, linkUrl, choices) {
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sectionID", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "descriptionID", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isAnswer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "choiceIconUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isUnsubscribeButton", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "text", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "imageUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "imageLinkUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nextSectionID", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "linkUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "choices", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.config = config;
        this.sectionID = sectionID;
        this.descriptionID = descriptionID;
        this.isAnswer = isAnswer;
        this.choiceIconUrl = choiceIconUrl;
        this.isUnsubscribeButton = isUnsubscribeButton;
        this.text = DOMPurify.sanitize(text, { ADD_ATTR: ['target', 'rel'] });
        this.imageUrl = DOMPurify.sanitize(imageUrl, {
            ADD_TAGS: ['iframe'],
            ADD_ATTR: ['width', 'height', 'src', 'title', 'frameborder', 'allow', 'referrerpolicy', 'allowfullscreen'],
        });
        this.imageLinkUrl = imageLinkUrl;
        this.nextSectionID = nextSectionID;
        this.linkUrl = linkUrl;
        this.choices = choices;
    }
    iconURL() {
        return this.config.cdnBaseURL + this.choiceIconUrl;
    }
    imageURL() {
        return this.config.cdnBaseURL + this.imageUrl;
    }
    isIframe() {
        return this.imageUrl.startsWith('<iframe');
    }
}
